import React from "react";
import { Link } from "react-router-dom";
import "./About.css"; // reuse existing styles
import DIRECTORS from "../data/directors";

export default function Leadership() {
  return (
    <div className="about-page">
      {/* HERO (reusing about theme) */}
      <section className="about-hero">
        <div className="about-hero__bg" />
        <div className="container">
          <div className="about-hero__content">
            <span className="badge">👔 Leadership</span>
            <h1 className="about-hero__title">
              Our <em>Leadership</em>
            </h1>
            <p className="about-hero__subtitle">
              Our leadership team brings vision, integrity, and passion to
              Sunaharco. Their journey and commitment drive our mission of
              sustainability and excellence.
            </p>
          </div>
        </div>
      </section>

      {/* DIRECTORS */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <span className="badge">🌟 Team</span>
            <h2 className="section-title">Meet Our Directors</h2>
          </div>

          <div className="values-grid">
            {DIRECTORS.map((d) => (
              <Link key={d.slug} to={`/leadership/${d.slug}`} className="value-card" aria-label={`View profile of ${d.name}`}>
                <img src={d.src} alt={d.name} className="value-card__image" />
                <h4 className="value-card__title">{d.name}</h4>
                <p>
                  <strong>{d.designation}</strong>
                </p>
                <p className="value-card__desc">{d.story}</p>
                <p>
                  <strong>Vision:</strong> {d.vision}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
